const getApiBase = () =>
  process.env.REACT_APP_API_BASE_URL || window.location.origin;

export default getApiBase;
